var exports = {
  "kL": "GroupDMAvatar.module__container___TTFTUm",
  "kg": "GroupDMAvatar.module__statusDot___TTFTUm",
  "O0": "GroupDMAvatar.module__iconImageContainer___TTFTUm",
  "c4": "GroupDMAvatar.module__defaultIconContainer___TTFTUm",
  "DE": "GroupDMAvatar.module__defaultIcon___TTFTUm",
  "EQ": "GroupDMAvatar.module__multiAvatarContainer___TTFTUm",
};

module.exports = exports;
